import React, { useState, useEffect, useCallback } from 'react';
import './assets/styles/base/yt-index.css';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import CustomAppBar from './components/AppBar';
import NotificationDrawer from './components/NotificationDrawer'
import NewDocument from './components/NewDocument'
import DocumentSearch from './components/DocumentSearch'
import SiteSelector from './SiteSelector'
import AlertNotification from './components/AlertNotification'
import { BrowserRouter as Router, Route, Routes, useLocation, Link } from "react-router-dom";
import { validateToken } from './functions/validate';
// import { config } from './config';
import { jwtDecode } from 'jwt-decode';
import { getUserByEmail } from './axios/user';
import Home from './components/Home';
import { Outlet, useNavigate, Navigate } from 'react-router-dom';
import { useRedirect } from './functions/context';
import { RedirectProvider } from './functions/context';
import Landing from './components/Landing';
import PublicLanding from './components/PublicLanding';
import PageNotFoundHandler from './components/PageNotFoundHandler';
import ErrorFallbackPage from './components/ErrorFallbackPage';


import {
  ApiManager,
  SiteVersion,
  SessionManager,
  sessionService,
  SessionTimeoutService,
  SessionTimeoutDialog,
  ValidationUtility,
  HandlerUtility,
} from './components/ComponentsLibrary';

import {
  NewWorkitem,
  NextWorkitem,
  QueueWorkflow,
  QueueCompleted,
  CaseView,
  MyYTrac,
  NewWalkIn,
  ActionTakenDetails,
} from './components/ComponentsLibrary';

import ManageTestCase from './TestModules/ManageTestCase';
import ManageTestComponents from './components/ManageTestComponents';

import { NavigationProvider } from './functions/NavigationContext';
import { AuthProvider, useAuthContext } from './functions/AuthContext';
import { ConfigProvider, useConfigContext } from './functions/ConfigContext';
import { default as ProtectedRoute } from './functions/ProtectedRoute';
import PermissionProtectedRoute from './functions/PermissionProtectedRoute'; // New permission protection


const PublicLayout = () => {
  return (
    <div style={{height: '100%', width: '100%'}}>
      <main style={{height: '100%', width: '100%'}}>
        <Outlet />
      </main>
    </div>
  );
};

const AppLayout = () => {

  const navigate = useNavigate();
  const location = useLocation();
  const isSiteSelect = location.pathname === '/siteselect';

  const { redirecting, } = useRedirect();

  const [activeView, setActiveView] = useState(1); // Track which button is clicked for right panel view
  const [searchQuery, setSearchQuery] = useState('');
  const [batch, setBatch] = useState('');
  const [open, setOpen] = useState(false); // For Drawer control
  const [toggleContentKey, setToggleContentKey] = useState(''); // For Drawer control
  const [anchorElProfile, setAnchorElProfile] = useState(null);

  // Session timeout states
  const [showTimeoutWarning, setShowTimeoutWarning] = useState(false);
  const [timeoutDialogContent, setTimeoutDialogContent] = useState(null);

  const { configLibrary } = useConfigContext();

  // Initialize session timeout monitoring
  useEffect(() => {
    const handleShowWarning = (warningContent) => {
      setTimeoutDialogContent(warningContent);
      setShowTimeoutWarning(true);
    };

    const handleHideWarning = () => {
      setShowTimeoutWarning(false);
      setTimeoutDialogContent(null);
    };

    const handleCountdownUpdate = (updatedContent) => {
      setTimeoutDialogContent(updatedContent);
    };

    const handleLogout = () => {
      setShowTimeoutWarning(false);
      setTimeoutDialogContent(null);
      navigate('/siteselect');
    };

    // Initialize session timeout service
    const initializeSessionTimeout = async () => {
      try {
        await SessionTimeoutService.initialize({
          onShowWarning: handleShowWarning,
          onHideWarning: handleHideWarning,
          onCountdownUpdate: handleCountdownUpdate,
          onLogout: handleLogout
        });
      } catch (error) {
        console.error('Failed to initialize session timeout service:', error);
      }
    };
    
    initializeSessionTimeout();

    // Cleanup on unmount
    return () => {
      SessionTimeoutService.cleanup();
    };
  }, [navigate]);

  // Handle extend session
  const handleExtendSession = () => {
    SessionTimeoutService.extendSession();
  };

  // Handle close warning (user clicks X) - Same functionality as Extend Session
  const handleCloseWarning = () => {
    SessionTimeoutService.extendSession();
  };

  const tokenValidate = useCallback(async () => {
    let config = {};
    const isRedirectedFrom = SessionManager.GetValueFromSession(SessionManager.RedirectedFromIDPKey);
    
    if (!redirecting) {
      if (isRedirectedFrom && isRedirectedFrom === 'true') {
        ValidationUtility.ValidateTokenFromIDP(configLibrary, navigate);
      }
    }
    else {
      return;
    }
  }, [configLibrary, navigate, redirecting]);

  
  /* useEffect(() => {
    if (!redirecting) {
      // debugger;
      tokenValidate();  // TO-DO: Modify Code - Uncomment before Deployment
    }
  }, [redirecting]);  */
  
/* 
  useEffect(() => {
    navigate("/siteselect"); // Navigate to Site Selection page when the app loads
  }, []); */

  const handleProfileMenuOpen = (event) => {
    setAnchorElProfile(event.currentTarget);
  };

  const handleProfileMenuClose = () => {
    setAnchorElProfile(null);
  };

  // Toggle the drawer
  const toggleDrawer = (newOpen, contentKey) => () => {
    setOpen(newOpen);
    setToggleContentKey(contentKey);
  }; 


  return (
    <>
    {/* Top Navigation Bar */}
    {!isSiteSelect &&
          <CustomAppBar
            handleProfileMenuOpen={handleProfileMenuOpen}
            anchorElProfile={anchorElProfile}
            handleProfileMenuClose={handleProfileMenuClose}
            toggleDrawer={toggleDrawer}
            onAdminClick={() => setActiveView('documentSearch')}
            onNewClick={() => setActiveView('default')}
          />
        }
      <NotificationDrawer open={open} toggleDrawer={toggleDrawer} togglekey={toggleContentKey} />
      <main style={{height: '100%', width: '100%'}}>
        <Outlet />
      </main>

      <SessionTimeoutDialog
        open={showTimeoutWarning}
        dialogContent={timeoutDialogContent}
        onExtendSession={handleExtendSession}
        onClose={handleCloseWarning}
      />
      
      {/*<nav>
        <Link to="/documentsearch">DocumentSearch</Link> | 
        <Link to="/newdocument">NewDocument</Link>
      </nav>*/}
      

    </>
  );
};


function App() {
 

  return (
    <div className="app-container">

      {/* <NewDocument />
      <DocumentSearch/>  */}
      <React.Suspense fallback={<div>Loading config...</div>}>
        <ConfigProvider>
          <AuthProvider>
            <Router>
              <RedirectProvider>
                <NavigationProvider>
                  <Routes>
                    {/* Default Route - Redirect to Dashboard */}
                    {/*  <Route path="/" element={<navigate to="/siteselect" replace />} /> */}

                    <Route element={<PublicLayout />}>
                      <Route path="/" element={<PublicLanding />} />
                    </Route>

                    <Route element={<HandlerUtility.BackButtonHandler />}>
                      <Route path="/siteselect" element={<SiteSelector />} />
                      <Route path="/home" element={<Home />} />
                      <Route path='/landing' element={<Landing />} />
                      <Route path="/siteversion" element={<SiteVersion />} />

                      <Route element={<ProtectedRoute />}>
                        <Route element={<AppLayout />}>
                          <Route path="/documentsearch" 
                            element={
                              <PermissionProtectedRoute requiredPermission={["btnNewDocument", "btnViewDocument"]}>
                                <DocumentSearch />
                              </PermissionProtectedRoute>
                            } 
                          />
                          <Route path="/newdocument" 
                            element={
                              <PermissionProtectedRoute requiredPermission="btnNewDocument">
                                <NewDocument />
                              </PermissionProtectedRoute>
                            } 
                          />
                          <Route path="/newworkitem" 
                            element={
                              <PermissionProtectedRoute requiredPermission="btnNewWorkflow">
                                <NewWorkitem />
                              </PermissionProtectedRoute>
                            } 
                          />
                          <Route path="/nextworkitem" 
                            element={
                              <PermissionProtectedRoute requiredPermission="btnNext">
                                <NextWorkitem />
                              </PermissionProtectedRoute>
                            } 
                          />
                          <Route path="/queueworkflow" 
                          element={
                            <PermissionProtectedRoute requiredPermission="btnQueue">
                              <QueueWorkflow />
                            </PermissionProtectedRoute>
                          } />
                          <Route path="/completed" 
                          element={
                            <PermissionProtectedRoute requiredPermission="btnCompleted">
                              <QueueCompleted />
                            </PermissionProtectedRoute>
                          } />
                          <Route path="/newwalkin" 
                            element={
                              <PermissionProtectedRoute requiredPermission="btnNewWalkIn">
                                <NewWalkIn/>
                              </PermissionProtectedRoute>
                            } 
                          />
                           <Route path="/caseview" 
                            element={
                              <PermissionProtectedRoute requiredPermission="btnViewCase">
                                <CaseView />
                              </PermissionProtectedRoute>
                            } 
                          />
                          <Route path="/myytrac" 
                          element={
                            <PermissionProtectedRoute requiredPermission="btnMyYTrac">
                              <MyYTrac />
                            </PermissionProtectedRoute>
                          } />

                           <Route path="/actionTakenDetails" 
                            element={
                            <ActionTakenDetails />
                          } />


                          <Route path="/managetest" element={<ManageTestComponents />} />
                          <Route path="/managecase" element={<ManageTestCase />} />

                          {/* 🔍 ADD: Simple error fallback page */}
                          <Route path="/errorFallbackPage" element={<ErrorFallbackPage />} />

                          {/* 🔍 IMPORTANT: This wildcard route MUST be the last route */}
                          <Route path="*" element={<PageNotFoundHandler />} />
                        </Route>
                      </Route>
                    </Route>

                  </Routes>
                </NavigationProvider>
              </RedirectProvider>
            </Router>
          </AuthProvider>
        </ConfigProvider>
      </React.Suspense>
    </div>
  );
}

export default App;
